import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './EmptyText.module.css';

export interface EmptyTextProps {
  /** Defaults to "None." */
  children?: ReactNode;
}

export function EmptyText({ children }: EmptyTextProps) {
  const { t } = useTranslation();
  return <p className={classes.empty}>{children ?? t('ui.none')}</p>;
}
